import { Injectable } from '@angular/core';

import { DataEntityWorkflow } from '@osos/shared/api';

import { ParserBase } from '../../bases';

import { DataEntityWorkflowPresenterModel } from '@osos/shared/types';
import { WorkflowStepFactoryService } from '../../factories/workflow-step-factory/workflow-step-factory.service';

@Injectable()
export class DataEntityWorkflowParserService extends ParserBase<
  DataEntityWorkflow,
  DataEntityWorkflowPresenterModel
> {
  constructor(private workflowStepFactoryService: WorkflowStepFactoryService) {
    super(DataEntityWorkflow, DataEntityWorkflowPresenterModel, 1);
  }
  getPresenterModel(
    model: DataEntityWorkflow,
  ): DataEntityWorkflowPresenterModel {
    const presenter = {} as DataEntityWorkflowPresenterModel;
    presenter.id = model.id;
    presenter.isDefault = model.isDefault;
    presenter.name = model.name ?? {
      en: 'Main workflow',
      ar: 'سير العمل الرئيسي',
    };
    presenter.steps = model.steps.map((step) =>
      this.workflowStepFactoryService.createPresenterModel(step),
    );
    return presenter;
  }
  getDataModel(
    presenter: DataEntityWorkflowPresenterModel,
  ): DataEntityWorkflow {
    const model = {
      id: presenter.id,
      isDefault: presenter.isDefault,
      name: presenter.name ?? { en: 'Main workflow', ar: 'سير العمل الرئيسي' },
      steps: presenter.steps?.map((s) =>
        this.workflowStepFactoryService.createDataModel(s),
      ),
    } as DataEntityWorkflow;

    return model;
  }
}
